export const SET_EDITOR_MODE = 'publisherStoryEditor/SET_EDITOR_MODE';
export const SET_LAST_VISITED_SNAP_PUB_URL = 'publisherStoryEditor/SET_LAST_VISITED_SNAP_PUB_URL';
export const SET_ACTIVE_EDITION = 'publisherStoryEditor/SET_ACTIVE_EDITION';
export const EXPORT_TO_AD_MANAGER = 'EXPORT_TO_AD_MANAGER';
export const ARTICLE_IMPORT = 'publisherStoryEditor/ARTICLE_IMPORT';
export const ARTICLE_INGEST_URL = 'publisherStoryEditor/ARTICLE_INGEST_URL';
export const ARTICLE_IMPORT_DIFFBOT = 'publisherStoryEditor/ARTICLE_IMPORT_DIFFBOT';
export const TOGGLE_MEDIA_LIBRARY_DRAWER = 'publisherStoryEditor/TOGGLE_MEDIA_LIBRARY_DRAWER';
